import { enrichConvertersRegistry } from '../utils/convertersRegistry'
import { genericsConverterMap } from './genericsPropsToCss'

/**
 * Enriches the converters registry with all generic style property converters.
 * Generic converters handle generic or reusable style property patterns.
 */
export function enrichGenericConverters(): void {
	// Register all generic converters
	Object.entries(genericsConverterMap).forEach(([key, converter]) => {
		enrichConvertersRegistry(key, converter)
	})
}
